import React, { useState, useEffect, useContext } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { LeadService, Lead, LeadRequest } from "./lead.service";
import { LifecycleStage } from "./lifecycle.service";
import CollapseHeader from "../../../core/common/collapse-header";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import {
  accountType,
  documentType,
  LocaleData,
  statusList,
} from "../../../core/common/selectoption/selectoption";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import male from "../../../../src/assets/male.png";
import axios from "axios";
import { API_BASE_URL } from "../../../environment";
import { getAuthHeaders } from "../../../utils/authUtils";
import { AuthContext } from "../../../context/authcontext";
import LeadForm from "./leadForm";
import { useLeadFormData, LeadFormDataProvider } from "./leadFormDataContext";
import company from "../../../../src/assets/company.png";
import { formatCustomDateTime } from "../../../utils/dateUtils";
import { transformLookupLeadToLead } from "../utils/lookupTransforms";
import {
  showSuccessAlert,
  showErrorAlert,
} from "../../uiInterface/base-ui/alertservice";
import { getLifecycleTypeName } from "../../../utils/lifecycleUtils";
import Activities from "../../../components/Tabs/Activities";
import Notes from "../../../components/Tabs/Notes";
import Files from "../../../components/Tabs/Files";
import Tasks from "../../../components/Tabs/Tasks";
import Email from "../../../components/Tabs/Email";
import ProductsServices from "../../../components/Tabs/ProductsServices";
import Chat from "../../../components/Tabs/Chat";
import Tabs from "../../../components/Tabs/tabs";
import { useTenantChange } from "../../../hooks/useTenantChange";
import { getStageColorByOrder } from "../../../utils/stageColors";
import { useEmailProviders } from "../../../hooks/useEmailProviders";
import ComposeEmail from "../../application/components/email/ComposeEmail";
import CustomFieldDisplay from "../../../components/CustomFieldDisplay";
import Tooltip from "@mui/material/Tooltip";
import MarkStatusModal from "../deals/MarkStatusModal";
import SalesActivityModal from "../salesActivity/SalesActivityModal";

interface LeadDetailsContentProps {
  isEditLeadOpen: boolean;
  setIsEditLeadOpen: (value: boolean) => void;
}

const LeadDetailsContent = ({ isEditLeadOpen, setIsEditLeadOpen }: LeadDetailsContentProps) => {
  const route = all_routes;
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedTenantId, auth } = useContext(AuthContext);
  const { lifecycleStages: contextLifecycleStages } = useLeadFormData();
  const [lead, setLead] = useState<Lead | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lifecycleStages, setLifecycleStages] = useState<LifecycleStage[]>([]);
  const [stagesLoading, setStagesLoading] = useState(true);

  const [updatingStage, setUpdatingStage] = useState(false);
  const [updatingPriority, setUpdatingPriority] = useState(false);
  const [updateMessage, setUpdateMessage] = useState<string | null>(null);
  const [activitiesRefreshTrigger, setActivitiesRefreshTrigger] = useState(0);

  const [addcomment, setAddComment] = useState(false);
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});
  const [openModal, setOpenModal] = useState(false);

  const [isUpdating, setIsUpdating] = useState(false);
  const [editError, setEditError] = useState<string>("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string>("");
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const { hasConnectedProviders, loading: emailProvidersLoading } =
    useEmailProviders();
  const [isComposeEmailOpen, setIsComposeEmailOpen] = useState(false);
  const [composeOpenCounter, setComposeOpenCounter] = useState(0);

  const [showMarkStatusModal, setShowMarkStatusModal] = useState(false);
  const [showSalesActivityModal, setShowSalesActivityModal] = useState(false);

  const handleMarkStatusSuccess = async () => {
    if (!lead?.lead_id || !selectedTenantId) return;
    try {
      const refreshResponse = await LeadService.getLeadLookup(lead.lead_id, Number(selectedTenantId));
      setLead(transformLookupLeadToLead(refreshResponse));
    } catch (error) {
      console.error("Failed to refresh lead after status mark", error);
    }
  };

  const clearLeadData = () => {
    setLead(null);
    setError(null);
    setLoading(true);
  };

  useTenantChange({
    onTenantChange: () => {
      clearLeadData();
      navigate("/leads");
    },
    clearData: clearLeadData,
  });

  const togglecomment = () => {
    setAddComment((prevState) => !prevState);
  };

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};

    for (let i = 0; i < 10; i++) {
      starsState[i] = false;
    }
    setStars(starsState);
  };

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const createCompanyUrl = (lead: any): string => {
    if (!lead.company?.company_id) return "#";
    return `/companies/${lead.company.company_id}`;
  };

  const createContactUrl = (lead: any): string => {
    if (!lead.primary_contact?.contact_id) return "#";
    return `/contacts/${lead.primary_contact.contact_id}`;
  };

  const handleStageUpdate = async (stageId: number | null) => {
    if (!lead?.lead_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/lead/${lead.lead_id}/`,
        {
          lifecycle_type_stage_id: stageId,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/lead/?lead_id=${lead.lead_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedLeadData = refreshResponse.data;
      const transformedLead = transformLookupLeadToLead(updatedLeadData);

      setLead(transformedLead);
      setUpdateMessage("Lead stage updated successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error updating lead stage:", error);
      setUpdateMessage("Failed to update lead stage");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };

  const handlePriorityUpdate = async (priority: string) => {
    if (!lead?.lead_id || !selectedTenantId) return;

    setUpdatingPriority(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/lead/${lead.lead_id}/`,
        {
          priority: priority,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/lead/?lead_id=${lead.lead_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedLeadData = refreshResponse.data;
      const transformedLead = transformLookupLeadToLead(updatedLeadData);

      setLead(transformedLead);
      setUpdateMessage("Lead priority updated successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error updating lead priority:", error);
      setUpdateMessage("Failed to update lead priority");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingPriority(false);
    }
  };

  const handleDeleteLead = async () => {
    if (!lead?.lead_id || isDeleting) return;

    setIsDeleting(true);
    setDeleteError("");

    try {
      await LeadService.deleteLead(lead.lead_id);

      setOpenModal(false);

      setShowDeleteLoader(true);

      setTimeout(() => {
        setShowDeleteLoader(false);
        navigate(route.leadsList);
      }, 1500);
    } catch (error: any) {
      console.error("Error deleting lead:", error);
      setDeleteError(
        error.response?.data?.message ||
        "Failed to delete lead. Please try again."
      );
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteError("");
    setOpenModal(false);
  };

  const handleMarkAsActive = async () => {
    if (!lead?.lead_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/lead/${lead.lead_id}/`,
        {
          is_archive: false,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/lead/?lead_id=${lead.lead_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedLeadData = refreshResponse.data;
      const transformedLead = transformLookupLeadToLead(updatedLeadData);

      setLead(transformedLead);
      setUpdateMessage("Lead marked as active successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error marking lead as active:", error);
      setUpdateMessage("Failed to mark lead as active");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };

  const handleMarkAsArchive = async () => {
    if (!lead?.lead_id || !selectedTenantId) return;

    setUpdatingStage(true);
    setUpdateMessage(null);

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/lead/${lead.lead_id}/`,
        {
          is_archive: true,
          tenant_id: selectedTenantId,
        },
        {
          headers: getAuthHeaders(),
        }
      );

      const refreshResponse = await axios.get(
        `${API_BASE_URL}/lookup/lead/?lead_id=${lead.lead_id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const updatedLeadData = refreshResponse.data;
      const transformedLead = transformLookupLeadToLead(updatedLeadData);

      setLead(transformedLead);
      setUpdateMessage("Lead marked as archived successfully!");

      setActivitiesRefreshTrigger((prev) => prev + 1);

      setTimeout(() => setUpdateMessage(null), 3000);
    } catch (error) {
      console.error("Error marking lead as archived:", error);
      setUpdateMessage("Failed to mark lead as archived");

      setTimeout(() => setUpdateMessage(null), 3000);
    } finally {
      setUpdatingStage(false);
    }
  };

  const handleSendEmail = () => {
    setComposeOpenCounter((prev) => prev + 1);
    setIsComposeEmailOpen(true);
  };

  const handleCloseComposeEmail = () => {
    setIsComposeEmailOpen(false);
  };

  const handleMinimizeComposeEmail = () => {
    setIsComposeEmailOpen(false);
  };

  const getPrimaryEmail = () => {
    if (lead?.primary_contact?.primary_email) {
      return lead.primary_contact.primary_email;
    }
    return "";
  };

  const isEmailEnabled =
    !emailProvidersLoading && hasConnectedProviders && getPrimaryEmail() !== "";

  const getEmailDisabledReason = () => {
    if (emailProvidersLoading) return "Checking email integration...";
    if (!hasConnectedProviders) return "Email is not integrated";
    if (!lead?.primary_contact) return `No contact attached to this ${getLifecycleTypeName('LEAD')}`;
    if (!getPrimaryEmail()) return "Attached contact has no email address";
    return "Email is not available";
  };

  const handleRefreshData = async () => {
    if (!id || !selectedTenantId) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/lookup/lead/?lead_id=${id}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const leadData = response.data;
      const transformedLead = transformLookupLeadToLead(leadData);

      setLead(transformedLead);
      setActivitiesRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      console.error("Error refreshing lead data:", error);
    }
  };

  const handleEditSubmit = async (formData: Partial<LeadRequest>) => {
    if (!lead?.lead_id || isUpdating) return;

    setIsUpdating(true);
    setEditError("");

    try {
      const updatedLead = await LeadService.updateLead(
        lead.lead_id,
        formData as any
      );

      setLead(updatedLead);

      setActivitiesRefreshTrigger((prev) => prev + 1);

      closeOffcanvas("offcanvas_edit_lead");

      setTimeout(() => {
        showSuccessAlert(`Lead "${updatedLead.title}" updated successfully!`);
      }, 500);
    } catch (error: any) {
      console.error("Error updating lead:", error);
      setEditError("Failed to update lead. Please try again.");
      showErrorAlert("Failed to update lead. Please try again.");
      throw error;
    } finally {
      setIsUpdating(false);
    }
  };

  const closeOffcanvas = (offcanvasId: string) => {
    const modal = document.getElementById(offcanvasId);
    if (modal) {
      const closeButton = modal.querySelector(
        '[data-bs-dismiss="offcanvas"]'
      ) as HTMLElement;
      if (closeButton) {
        closeButton.click();
      } else {
        const bsOffcanvas = (window as any).bootstrap?.Offcanvas?.getInstance(
          modal
        );
        if (bsOffcanvas) {
          bsOffcanvas.hide();
        }
      }
    }
  };

  const DeletePreloader = () => {
    return (
      <div
        className="preloader"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div className="loader"></div>
        <p className="mt-3 text-muted">
          Lead deleted successfully. Redirecting...
        </p>
      </div>
    );
  };

  const sortbydata = [
    { value: "Sort By Date", label: "Sort By Date" },
    { value: "Ascending", label: "Ascending" },
    { value: "Descending", label: "Descending" },
  ];

  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];

  const priorityOptions = [
    {
      value: "High",
      label: "High",
      icon: (
        <i className="ti ti-square-rounded-filled me-1 text-danger circle" />
      ),
    },
    {
      value: "Medium",
      label: "Medium",
      icon: (
        <i className="ti ti-square-rounded-filled me-1 text-secondary circle" />
      ),
    },
    {
      value: "Low",
      label: "Low",
      icon: <i className="ti ti-square-rounded-filled me-1 text-info circle" />,
    },
  ];

  useEffect(() => {
    initializeStarsState();
  }, []);

  useEffect(() => {
    const editOffcanvas = document.getElementById("offcanvas_edit_lead");

    const handleHidden = () => {
      setIsEditLeadOpen(false);
    };

    if (editOffcanvas) {
      editOffcanvas.addEventListener("hidden.bs.offcanvas", handleHidden);
    }

    return () => {
      if (editOffcanvas) {
        editOffcanvas.removeEventListener("hidden.bs.offcanvas", handleHidden);
      }
    };
  }, []);

  useEffect(() => {
    const fetchLead = async () => {
      if (!id || !selectedTenantId) {
        setError("Lead ID or tenant ID not provided");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setStagesLoading(true);

        const response = await axios.get(
          `${API_BASE_URL}/lookup/lead/?lead_id=${id}&tenant_id=${selectedTenantId}`,
          {
            headers: getAuthHeaders(),
          }
        );

        const leadData = response.data;
        const transformedLead = transformLookupLeadToLead(leadData);

        setLead(transformedLead);

        if (
          leadData.lifecycle_type_stage &&
          Array.isArray(leadData.lifecycle_type_stage)
        ) {
          const sortedStages = leadData.lifecycle_type_stage.sort(
            (a: any, b: any) => a.stage_order - b.stage_order
          );
          setLifecycleStages(sortedStages);
        }

        setStagesLoading(false);
        setLoading(false);
      } catch (err: any) {
        console.error("Error fetching lead details:", err);

        if (err?.response?.status === 404) {
          navigate(route.leads);
          return;
        }

        setError("Failed to fetch lead details");
        setLoading(false);
        setStagesLoading(false);
      }
    };

    fetchLead();
  }, [id, selectedTenantId]);

  const refreshLeadData = async () => {
    const leadId = id || lead?.lead_id;
    if (!leadId || !selectedTenantId) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/lookup/lead/?lead_id=${leadId}&tenant_id=${selectedTenantId}`,
        {
          headers: getAuthHeaders(),
        }
      );

      const leadData = response.data;
      const transformedLead = transformLookupLeadToLead(leadData);

      setLead(transformedLead);
    } catch (err: any) {
      console.error("Error refreshing lead details:", err);
    }
  };
  useEffect(() => {
    if (contextLifecycleStages.length > 0 && lifecycleStages.length === 0) {
      setLifecycleStages(contextLifecycleStages);
      setStagesLoading(false);
    }
  }, [contextLifecycleStages, lifecycleStages]);
  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("LEAD")} Overview
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px" }}
                  >
                    <div className="text-center">
                      <div
                        className="spinner-border text-primary mb-3"
                        role="status"
                        style={{ width: "3rem", height: "3rem" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <h5 className="text-muted">
                        Loading {getLifecycleTypeName("LEAD")} details...
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !lead) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("LEAD")} Overview
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="alert alert-danger">
                {error || "Lead not found"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isStageActive = (stageId: number): boolean => {
    if (!lead.lifecycle_type_stage?.lifecycle_type_stage_id) return false;

    const currentStageId = lead.lifecycle_type_stage.lifecycle_type_stage_id;
    const currentStage = lifecycleStages.find(
      (stage) => stage.lifecycle_type_stage_id === currentStageId
    );
    const checkStage = lifecycleStages.find(
      (stage) => stage.lifecycle_type_stage_id === stageId
    );

    if (!currentStage || !checkStage) return false;

    return checkStage.stage_order <= currentStage.stage_order;
  };
  return (
    <>
      {/* Show delete loader overlay */}
      {showDeleteLoader && <DeletePreloader />}

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {" "}
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      {getLifecycleTypeName("LEAD")} Overview
                    </h4>
                  </div>
                  <div className="col-sm-8 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* Success/Error Message */}
              {updateMessage && (
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className={`alert ${updateMessage.includes("successfully")
                        ? "alert-success"
                        : "alert-danger"
                        } alert-dismissible fade show`}
                      role="alert"
                    >
                      {updateMessage}
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setUpdateMessage(null)}
                      ></button>
                    </div>
                  </div>
                </div>
              )}
              {/* /Page Header */}
            </div>
          </div>
          <>
            <div className="row">
              <div className="col-md-12">
                {/* Lead User */}
                <div className="contact-head">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      {" "}
                      <ul className="contact-breadcrumb">
                        <li>
                          <Link to={route.leadsList}>
                            <i className="ti ti-arrow-narrow-left" />
                            {getLifecycleTypeName("LEAD")}
                          </Link>
                        </li>
                        <li>
                          {lead.title && lead.title.length > 80 ? (
                            <Tooltip title={lead.title} placement="top" arrow>
                              <p className="mb-1" style={{ cursor: "default" }}>
                                {`${lead.title.substring(0, 80)}...`}
                              </p>
                            </Tooltip>
                          ) : (
                            <p className="mb-1">{lead.title}</p>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card" style={{ position: 'relative' }}>
                  {lead.is_archive && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '150px',
                        height: '150px',
                        overflow: 'hidden',
                        zIndex: 10,
                        pointerEvents: 'none',
                      }}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          top: '10px',
                          left: '-53px',
                          backgroundColor: '#dc3545',
                          color: 'white',
                          padding: '6px 30px',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                          transform: 'rotate(-45deg)',
                          boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                          textAlign: 'center',
                          width: '150px',
                        }}
                      >
                        Archived
                      </div>
                    </div>
                  )}
                  <div className="card-body pb-2">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-center mb-2">
                        <div
                          className="avatar avatar-xl me-3 flex-shrink-0 border p-2 bg-light"
                          style={{ borderRadius: "50%" }}
                        >
                          <i
                            className="ti ti-chart-arcs"
                            style={{ color: "#824eeb", fontSize: "3rem" }}
                          />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                            {lead.title && lead.title.length > 30 ? (
                              <Tooltip title={lead.title} placement="top" arrow>
                                <h3 className="mb-0" style={{ cursor: "default" }}>
                                  {`${lead.title.substring(0, 30)}...`}
                                </h3>
                              </Tooltip>
                            ) : (
                              <h3 className="mb-0">{lead.title}</h3>
                            )}
                            {lead.is_active === false ? (
                              <Tooltip title={lead.lifecycle_status_reason?.reason_name || "Inactive"} placement="top" arrow>
                                <span
                                  className="badge badge-pill mb-1"
                                  style={{ backgroundColor: "#dc3545", color: "#fff", fontWeight: 500, padding: "4px 10px", fontSize: "11px", cursor: "default" }}
                                >
                                  Inactive
                                </span>
                              </Tooltip>
                            ) : lead.lifecycle_status_reason ? (
                              <Tooltip title={lead.lifecycle_status_reason.reason_name} placement="top" arrow>
                                <span
                                  className={`badge d-inline-flex align-items-center mb-1 ${lead.lifecycle_status_reason.lifecycle_status_reason_category_key === "WON" ? "bg-success" : "bg-secondary"}`}
                                  style={{ cursor: "default" }}
                                >
                                  <i className={`fa ${lead.lifecycle_status_reason.lifecycle_status_reason_category_key === "WON" ? "fa-trophy" : "fa-thumbs-down"} me-1`} />
                                  {lead.lifecycle_status_reason.lifecycle_status_reason_category_key === "WON" ? "Won" : "Lost"}
                                </span>
                              </Tooltip>
                            ) : null}
                          </div>
                          <p className="mb-1">
                            <i className="ti ti-building me-1" />
                            {lead.company?.company_name || "No Company"}
                          </p>
                        </div>
                      </div>
                      <div className="contacts-action">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div className="mb-2">
                            <Select
                              options={lifecycleStages.map((stage) => ({
                                value: stage.lifecycle_type_stage_id,
                                label: stage.stage_name,
                              }))}
                              value={
                                lifecycleStages.find(
                                  (stage) =>
                                    stage.lifecycle_type_stage_id ===
                                    lead.lifecycle_type_stage
                                      ?.lifecycle_type_stage_id
                                )
                                  ? {
                                    value:
                                      lead.lifecycle_type_stage
                                        ?.lifecycle_type_stage_id,
                                    label:
                                      lead.lifecycle_type_stage?.stage_name,
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                handleStageUpdate(option?.value || null)
                              }
                              placeholder="Select stage"
                              isClearable={false}
                              isLoading={updatingStage}
                              isDisabled={updatingStage}
                              className="min-w-200"
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minWidth: "200px",
                                  backgroundColor: "#28a745",
                                  borderColor: "#28a745",
                                  color: "white",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: "white",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: "rgba(255, 255, 255, 0.8)",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </div>
                          {isEmailEnabled ? (
                            <button
                              className="btn btn-secondary d-flex align-items-center mb-2"
                              onClick={handleSendEmail}
                              title="Send Email"
                            >
                              <i className="ti ti-mail me-2" />
                              Send Email
                            </button>
                          ) : (
                            <Tooltip title={getEmailDisabledReason()} placement="top" arrow>
                              <span
                                className="btn btn-secondary d-flex align-items-center mb-2"
                                style={{ cursor: "not-allowed", opacity: 0.5 }}
                              >
                                <i className="ti ti-mail me-2" />
                                Send Email
                              </span>
                            </Tooltip>
                          )}
                          <Link
                            to="#"
                            className="btn-icon d-flex align-items-center justify-content-center mb-2"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvas_edit_lead"
                            title="Edit Lead"
                            onClick={() => setIsEditLeadOpen(true)}
                          >
                            <i className="ti ti-edit-circle fs-16" />
                          </Link>
                          <Link
                            className="btn-icon d-flex align-items-center justify-content-center mb-2"
                            to="#"
                            onClick={(e) => { e.preventDefault(); setShowSalesActivityModal(true); }}
                            title="Log Activity"
                          >
                            <i className="ti ti-clipboard-list fs-16" />
                          </Link>
                          <div className="dropdown">
                            <Link
                              to="#"
                              className="btn-icon d-flex align-items-center justify-content-center mb-2"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              title="More Actions"
                            >
                              <i className="ti ti-dots-vertical fs-16" />
                            </Link>
                            <div className="dropdown-menu dropdown-menu-end dropup" style={{ minWidth: "220px" }}>
                              {lead.is_archive ? (
                                <Link
                                  className="dropdown-item d-flex align-items-center"
                                  to="#"
                                  onClick={() => handleMarkAsActive()}
                                >
                                  <i className="ti ti-check text-success me-2" />
                                  Mark as Active
                                </Link>
                              ) : (
                                <Link
                                  className="dropdown-item d-flex align-items-center"
                                  to="#"
                                  onClick={() => handleMarkAsArchive()}
                                >
                                  <i className="ti ti-archive-off text-warning me-2" />
                                  Mark as Archive
                                </Link>
                              )}
                              <Link
                                className="dropdown-item d-flex align-items-center"
                                to="#"
                                onClick={(e) => { e.preventDefault(); setShowMarkStatusModal(true); }}
                              >
                                <i className="ti ti-trophy text-info me-2" />
                                Mark as Lost/Won
                              </Link>

                              <Link
                                className="dropdown-item d-flex align-items-center"
                                to="#"
                                onClick={() => setOpenModal(true)}
                              >
                                <i className="ti ti-trash text-danger me-2" />
                                Delete
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Lead User */}
              </div>
              {/* Lead Sidebar */}
              <div className="col-xl-3 theiaStickySidebar">
                <div className="card">
                  <div className="card-body p-3">
                    <h6 className="mb-3 fw-semibold">
                      {getLifecycleTypeName("LEAD")} Information
                    </h6>
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Estimated Value</span>
                        <span className="col-6">
                          {lead.estimated_value
                            ? `${lead.currency_code || "$"
                            } ${Number(lead.estimated_value || 0).toFixed(4)}`
                            : "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Source</span>
                        <span className="col-6">
                          {lead.lifecycle_source?.lifecycle_source_display_name || (lead as any)?.source || "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Lifecycle Stage</span>
                        <span className="col-6">
                          <span
                            className={`badge ${getStageColorByOrder(
                              lifecycleStages.find(
                                (stage) =>
                                  stage.lifecycle_type_stage_id ===
                                  lead.lifecycle_type_stage
                                    ?.lifecycle_type_stage_id
                              )?.stage_order || 1
                            )}`}
                          >
                            {lead.lifecycle_type_stage?.stage_name || "Not Set"}
                          </span>
                        </span>
                      </li>
                    </ul>
                    <hr />
                    <CustomFieldDisplay
                      customFields={(lead as any)?.custom_fields}
                      showTitle={true}
                    />
                    {/* Assigned Team */}
                    <h6 className="mb-3 fw-semibold">Assigned Team</h6>
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="avatar avatar-md me-2 d-flex align-items-center justify-content-center bg-light"
                        style={{ width: 40, height: 40, borderRadius: "50%" }}
                      >
                        <i className="ti ti-users fs-24 text-primary" />
                      </div>
                      <div>
                        <div>
                          {lead.assigned_team &&
                            (lead.assigned_team.team_name ||
                              lead.assigned_team.name ||
                              "Not Assigned")}
                        </div>
                      </div>
                    </div>
                    <h6 className="mb-3 fw-semibold">Assigned User</h6>
                    <div className="d-flex align-items-center mb-3">
                      <span
                        className="avatar avatar-sm border rounded-circle p-1 me-2"
                        style={{ borderRadius: "50%" }}
                      >
                        <img
                          src={lead.assigned_user?.avatar_url || male}
                          alt="Image"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </span>
                      <p>{lead.assigned_user?.full_name || "Not Assigned"}</p>
                    </div>

                    <hr />
                    <h6 className="mb-3 fw-semibold">Company</h6>
                    <div className="d-flex align-items-center">
                      <span
                        className="avatar avatar-sm border rounded-circle p-1 me-2"
                        style={{ borderRadius: "50%" }}
                      >
                        <img
                          src={lead.company?.avatar_url || company}
                          alt="Image"
                          style={{
                            borderRadius: "50%",
                          }}
                        />
                      </span>

                      <div
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        <Link to={createCompanyUrl(lead)} target="_blank">
                          {lead.company?.company_name || "Not specified"}
                        </Link>
                      </div>
                    </div>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Contact</h6>
                    <div className="d-flex align-items-center mb-3">
                      <span
                        className="avatar avatar-sm border rounded-circle p-1 me-2"
                        style={{ borderRadius: "50%" }}
                      >
                        <img
                          src={lead.primary_contact?.avatar_url || male}
                          alt="Image"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </span>
                      <Link
                        to={createContactUrl(lead)}
                        target="_blank"
                        style={{ textDecoration: "underline" }}
                      >
                        {lead.primary_contact?.full_name || "Not Assigned"}
                      </Link>
                    </div>
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Primary Phone</span>
                        <span className="col-6">
                          {lead.primary_contact?.primary_phone ||
                            "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Primary Email</span>
                        <span className="col-6">
                          {lead.primary_contact?.primary_email ||
                            "Not specified"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Job Title</span>
                        <span className="col-6">
                          {lead.primary_contact?.job_title ||
                            "Not specified"}
                        </span>
                      </li>
                    </ul>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Priority</h6>
                    <div className="priority-info">
                      <Select
                        options={priorityOptions}
                        value={
                          priorityOptions.find(
                            (option) => option.value === lead.priority
                          ) || null
                        }
                        onChange={(option) =>
                          handlePriorityUpdate(option?.value || "")
                        }
                        placeholder="Select priority"
                        isClearable={false}
                        isLoading={updatingPriority}
                        isDisabled={updatingPriority}
                        className="min-w-150"
                        formatOptionLabel={(option: any) => (
                          <div className="d-flex align-items-center">
                            {option.icon}
                            <span>{option.label}</span>
                          </div>
                        )}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            minWidth: "150px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                    <hr />

                    {/* Tags Section */}

                    <>
                      <h6 className="mb-3 fw-semibold">Tags</h6>
                      <ul className="social-info">
                        <li style={{ padding: '5px' }}>
                          {
                            lead?.tags?.insert && Array.isArray(lead.tags.insert) && lead.tags.insert.length > 0 ? (
                              lead.tags.insert.map((tag: any, index: number) => (
                                <span key={tag.entity_tag_id || index}
                                  className="badge me-1"
                                  style={{
                                    backgroundColor: '#824EEB',
                                    color: 'white'
                                  }}>
                                  {tag.entity_tag_name}
                                </span>
                              ))
                            ) : (
                              <span className="text-muted">No Tags Assigned</span>
                            )
                          }
                        </li>
                      </ul>
                    </>
                    <hr />


                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Created At</span>
                        <span className="col-6">
                          {formatCustomDateTime(lead.created_datetime)}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Created By</span>
                        <span className="col-6 d-flex align-items-center">
                          <span className="avatar avatar-xs me-1">
                            <img
                              src={lead.created_by?.avatar_url || male}
                              alt="Image"
                              style={{
                                width: "25px",
                                height: "20px",
                                borderRadius: "50%",
                              }}
                            />
                          </span>
                          <span>
                            {lead.created_by
                              ? `${lead.created_by.full_name}`
                              : "No User Found"}
                          </span>
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Last Modified</span>
                        <span className="col-6">
                          {formatCustomDateTime(lead.updated_datetime)}
                        </span>
                      </li>
                      <li className="row mb-0">
                        <span className="col-6">Modified By</span>
                        <span className="col-6 d-flex align-items-center">
                          <span className="avatar avatar-xs me-1">
                            <img
                              src={lead.updated_by?.avatar_url || male}
                              alt="Image"
                              style={{
                                width: "25px",
                                height: "20px",
                                borderRadius: "50%",
                              }}
                            />
                          </span>
                          {lead.updated_by
                            ? `${lead.updated_by.full_name}`
                            : "No User Found"}
                        </span>
                      </li>
                    </ul>

                  </div>

                </div>
              </div>
              {/* /Lead Sidebar */}
              {/* Lead Details */}
              <div className="col-xl-9">
                <div className="card mb-3">
                  <div className="card-body pb-0">
                    <h4 className="fw-semibold mb-3">
                      {getLifecycleTypeName("LEAD")} LifeCycle Status
                    </h4>
                    {stagesLoading ? (
                      <div className="d-flex align-items-center justify-content-center py-3">
                        <div
                          className="spinner-border spinner-border-sm text-primary me-2"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="text-muted">
                          Loading pipeline stages...
                        </span>
                      </div>
                    ) : lifecycleStages.length > 0 ? (
                      <div className="pipeline-list">
                        <ul>
                          {lifecycleStages.map((stage) => (
                            <li key={stage.lifecycle_type_stage_id}>
                              <Link
                                to="#"
                                className={
                                  isStageActive(stage.lifecycle_type_stage_id)
                                    ? getStageColorByOrder(stage.stage_order)
                                    : "bg-gray"
                                }
                                style={{
                                  pointerEvents: isStageActive(
                                    stage.lifecycle_type_stage_id
                                  )
                                    ? "auto"
                                    : "none",
                                  color: isStageActive(
                                    stage.lifecycle_type_stage_id
                                  )
                                    ? ""
                                    : "#fff",
                                }}
                              >
                                {stage.stage_name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <div className="text-center py-3">
                        <span className="text-muted">
                          No pipeline stages found
                        </span>
                      </div>
                    )}
                    <Tabs showProductsServicesTab={true} showChatTab={true} />
                  </div>
                </div>
                {/* Tab Content */}
                <div className="tab-content pt-0">
                  {/* Activities */}
                  <Activities
                    tenant_id={selectedTenantId}
                    related_entity_id={lead?.lead_id}
                    refreshTrigger={activitiesRefreshTrigger}
                    related_entity_name="lead"
                    crm_entity_id={lead?.crm_entity_id}
                  />
                  {/* /Activities */}

                  {/* Notes */}

                  <Notes
                    tenant_id={selectedTenantId}
                    related_entity_id={lead?.lead_id}
                    related_entity_name="lead"
                    refreshTrigger={activitiesRefreshTrigger}
                    onActivityUpdate={() =>
                      setActivitiesRefreshTrigger((prev) => prev + 1)
                    }
                  />

                  {/* /Notes */}

                  {/* Files */}

                  <Files
                    tenant_id={selectedTenantId}
                    related_entity_id={lead?.lead_id}
                    related_entity_name="lead"
                    refreshTrigger={activitiesRefreshTrigger}
                    onActivityUpdate={() =>
                      setActivitiesRefreshTrigger((prev) => prev + 1)
                    }
                  />

                  {/* /Files */}
                  {/* Tasks */}

                  <Tasks
                    tenant_id={selectedTenantId}
                    related_entity_id={lead?.lead_id}
                    related_entity_name="lead"
                    refreshTrigger={activitiesRefreshTrigger}
                    onActivityUpdate={() =>
                      setActivitiesRefreshTrigger((prev) => prev + 1)
                    }
                  />

                  {/* /Tasks */}

                  {/* Products & Services */}

                  <ProductsServices
                    tenant_id={selectedTenantId}
                    related_entity_id={lead?.lead_id}
                    related_entity_name="lead"
                    onActivityUpdate={() =>
                      setActivitiesRefreshTrigger((prev) => prev + 1)
                    }
                    onEntityUpdate={refreshLeadData}
                    currencyCode={lead?.currency_code}
                  />

                  {/* /Products & Services */}
                  {/* Email */}

                  <Email
                    contactIds={
                      lead?.primary_contact?.contact_id
                        ? [lead.primary_contact.contact_id]
                        : []
                    }
                  />

                  {/* /Email */}

                  <Chat
                    tenant_id={selectedTenantId}
                    contact_id={lead?.primary_contact?.contact_id}
                    isContactPage={true}
                    lifecycleName="lead"
                  />
                </div>
                {/* /Tab Content */}
              </div>
              {/* /Lead Details */}
            </div>
          </>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Create Contact */}
      <div
        className="modal custom-modal fade"
        id="create_contact"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-user-plus" />
                </div>
                <h3>Contact Created Successfully!!!</h3>
                <p>View the details of contact, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to={route.leadDetails} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Contact */}
      {/* Add Note */}
      <div
        className="modal custom-modal fade modal-padding"
        id="add_notes"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Notes</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="col-form-label">
                    Title <span className="text-danger"> *</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Note <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    defaultValue={""}
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Attachment <span className="text-danger"> *</span>
                  </label>
                  <div className="drag-attach">
                    <input type="file" />
                    <div className="img-upload">
                      <i className="ti ti-file-broken" />
                      Upload File
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 text-end modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    type="button"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Note */}
      {/* Create Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-check" />
                        </span>
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        defaultValue={""}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" /> Create a followup task
                      </label>
                    </div>
                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Call Log */}
      {/* Add File */}
      <div
        className="modal custom-modal fade custom-modal-two modal-padding"
        id="new_file"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New File</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="add-info-fieldset">
                <div className="add-details-wizard">
                  <ul className="progress-bar-wizard">
                    <li className="active">
                      <span>
                        <i className="ti ti-file" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Basic Info</h6>
                      </div>
                    </li>
                    <li>
                      <span>
                        <i className="ti ti-circle-plus" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Add Recipient</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <fieldset id="first-field-file">
                  <form>
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Choose Deal <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={dealsopen}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Document Type{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={documentType}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Assigned User{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <SelectWithImage2 />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Title <span className="text-danger"> *</span>
                            </label>
                            <input className="form-control" type="text" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Locale <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={LocaleData}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4>Signature</h4>
                            <ul className="nav sign-item">
                              <li className="nav-item">
                                <span
                                  className=" mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nosign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign1"
                                    name="email"
                                  />
                                  <label htmlFor="sign1">
                                    <span className="sign-title">
                                      No Signature
                                    </span>
                                    This document does not require a signature
                                    before acceptance.
                                  </label>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span
                                  className="active mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#use-esign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign2"
                                    name="email"
                                    defaultChecked
                                  />
                                  <label htmlFor="sign2">
                                    <span className="sign-title">
                                      Use e-signature
                                    </span>
                                    This document require e-signature before
                                    acceptance.
                                  </label>
                                </span>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className="tab-pane show active"
                                id="use-esign"
                              >
                                <div className="input-block mb-0">
                                  <label className="col-form-label">
                                    Document Signers{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="sign-content">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="mb-3">
                                        <input
                                          className="form-control"
                                          type="text"
                                          placeholder="Enter Name"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="d-flex align-items-center">
                                        <div className="float-none mb-3 me-3 w-100">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Email Address"
                                          />
                                        </div>
                                        <div className="input-btn mb-3">
                                          <Link to="#" className="add-sign">
                                            <i className="ti ti-circle-plus" />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Content <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Add Content"
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Reset
                          </button>
                          <button
                            className="btn btn-primary wizard-next-btn"
                            type="button"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
                <fieldset>
                  <form>
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4 className="mb-2">
                              Send the document to following signers
                            </h4>
                            <p>In order to send the document to the signers</p>
                            <div className="input-block mb-0">
                              <label className="col-form-label">
                                Recipients (Additional recipients)
                              </label>
                            </div>
                            <div className="sign-content">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter Name"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="d-flex align-items-center">
                                    <div className="float-none mb-3 me-3 w-100">
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Email Address"
                                      />
                                    </div>
                                    <div className="input-btn mb-3">
                                      <Link to="#" className="add-sign">
                                        <i className="ti ti-circle-plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Subject{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter Subject"
                            />
                          </div>
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Text{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Your document is ready"
                              defaultValue={""}
                            />
                          </div>
                          <button className="btn btn-light mb-3">
                            Send Now
                          </button>
                          <div className="send-success">
                            <p>
                              <i className="ti ti-circle-check" /> Document sent
                              successfully to the selected recipients
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            type="button"
                            data-bs-dismiss="modal"
                          >
                            Save &amp; Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add File */}
      {/* Connect Account */}
      <div className="modal custom-modal fade" id="create_email" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Connect Account</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">
                  Account type <span className="text-danger"> *</span>
                </label>
                <Select
                  className="select2"
                  options={accountType}
                  placeholder="Choose"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="mb-3">
                <h5 className="form-title">Sync emails from</h5>
                <div className="sync-radio">
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test1"
                      name="radio-group"
                      defaultChecked
                    />
                    <label htmlFor="test1">Now</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test2"
                      name="radio-group"
                    />
                    <label htmlFor="test2">1 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test3"
                      name="radio-group"
                    />
                    <label htmlFor="test3">3 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test4"
                      name="radio-group"
                    />
                    <label htmlFor="test4">6 Month Ago</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 text-end modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button
                  className="btn btn-primary"
                  data-bs-target="#success_mail"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                >
                  Connect Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Connect Account */}
      {/* Success Contact */}
      <div className="modal custom-modal fade" id="success_mail" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-mail-opened" />
                </div>
                <h3>Email Connected Successfully!!!</h3>
                <p>
                  Email Account is configured with "example@example.com". Now
                  you can access email.
                </p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to={route.leadDetails} className="btn btn-primary">
                    Go to email
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Success Contact */}

      {/* Delete Lead */}
      <Modal show={openModal} onHide={handleDeleteCancel}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Lead?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> {lead?.title}?
            </p>

            {/* Error message */}
            {deleteError && (
              <div className="alert alert-danger mt-3" role="alert">
                <div className="d-flex align-items-center">
                  <i className="ti ti-alert-circle me-2"></i>
                  <span>{deleteError}</span>
                  <button
                    type="button"
                    className="btn-close ms-auto"
                    aria-label="Close"
                    onClick={() => setDeleteError("")}
                  ></button>
                </div>
              </div>
            )}

            <div className="d-flex align-items-center justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-light me-2"
                onClick={handleDeleteCancel}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDeleteLead}
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Deleting...
                  </>
                ) : (
                  "Yes, Delete it"
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Delete Lead */}

      {/* Edit Lead Offcanvas */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvas_edit_lead"
        style={{ width: "550px" }}

      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit {getLifecycleTypeName("LEAD")}</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          {isEditLeadOpen && (
            <LeadForm
              lead={lead}
              onSubmit={handleEditSubmit}
              onCancel={() => closeOffcanvas("offcanvas_edit_lead")}
              isSubmitting={isUpdating}
              onRefreshData={handleRefreshData}
            />
          )}
        </div>
      </div>
      {/* /Edit Lead Offcanvas */}

      {/* Compose Email Modal */}
      <ComposeEmail
        key={`compose-email-${composeOpenCounter}`}
        isOpen={isComposeEmailOpen}
        onClose={handleCloseComposeEmail}
        onMinimize={handleMinimizeComposeEmail}
        draftData={{
          send_to: getPrimaryEmail(),
          subject: `Re: ${lead?.title || "Lead"}`,
        }}
        readOnlyRecipient={false}
        crm_entity_id={lead?.crm_entity_id}
        record_id={lead?.lead_id}
      />

      {showMarkStatusModal && lead && (
        <MarkStatusModal
          entityType="lead"
          entityId={lead.lead_id!}
          tenantId={Number(selectedTenantId)}
          currentStatusReasonId={lead.lifecycle_status_reason?.lifecycle_status_reason_id}
          onClose={() => setShowMarkStatusModal(false)}
          onSuccess={handleMarkStatusSuccess}
        />
      )}

      {showSalesActivityModal && lead && (
        <SalesActivityModal
          isVisible={showSalesActivityModal}
          onClose={() => setShowSalesActivityModal(false)}
          crmEntityId={lead.crm_entity_id}
          recordId={lead.lead_id}
          onSuccess={() => setActivitiesRefreshTrigger((prev) => prev + 1)}
        />
      )}
    </>
  );
};

const LeadDetails = () => {
  const [isEditLeadOpen, setIsEditLeadOpen] = useState(false);

  return (
    <LeadFormDataProvider isMainApiCompleted={true} shouldLoad={isEditLeadOpen}>
      <LeadDetailsContent
        isEditLeadOpen={isEditLeadOpen}
        setIsEditLeadOpen={setIsEditLeadOpen}
      />
    </LeadFormDataProvider>
  );
};

export default LeadDetails;
